import { getWeekOfMonth } from 'date-fns';
import getDay from '../../domain/utils/get-day';
import { ScheduleSliceState } from '../index';

export const markGameDays = (state: ScheduleSliceState) => {
  const monthName = new Date(state.currentYear, state.currentMonth).toLocaleDateString('ru-RU', { month: 'long' });
  const days = state.calendar[monthName];
  if (!days) return;
  for (const day of days) {
    const { date } = day;
    const dateObj = new Date(date);
    const isSomeYear = state.currentYear !== dateObj.getFullYear();
    if (isSomeYear) continue;
    const week = getWeekOfMonth(dateObj, { weekStartsOn: 1 });
    const weekDay = state.weeks[week - 1][getDay({ date: dateObj })];
    weekDay.status = 'game';
  }
};
